<template>
    <div class="container">
        <h3 v-if="team.name">Team: {{ team.name }}</h3>
        <team-card />
        <team-memberships-card />
        <projects-card />
        <playgrounds-card
          :playgrounds="teamPlaygrounds"
          :loading="loading.teamPlaygrounds"
          title="Team Playgrounds"
          @refresh="refreshPlaygrounds"
        />
        <subscriptions-card />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TeamCard from './TeamCard';
import TeamMembershipsCard from '../UserView/TeamMembershipsCard';
import SubscriptionsCard from './SubscriptionsCard';
import ProjectsCard from './ProjectsCard';
import PlaygroundsCard from '../PlaygroundView/PlaygroundsCard';

export default {
    components: {
        TeamCard,
        TeamMembershipsCard,
        SubscriptionsCard,
        ProjectsCard,
        PlaygroundsCard,
    },
    created() {
        this.fetchData();
    },
    computed: mapGetters(['team', 'teamPlaygrounds', 'loading']),
    methods: {
        ...mapActions(['getTeam', 'getTeamMemberships', 'getTeamProjects', 'getTeamSubscriptions', 'getTeamPlaygrounds']),
        async fetchData() {
            const { query: id } = this.$route.params;
            try {
                this.getTeamMemberships({ parent: 'teams', parentId: id });
                this.getTeamProjects(id);
                this.getTeamSubscriptions(id);
                this.getTeamPlaygrounds(id);
            } catch(e) {
                this.$notify.error({
                    title: "Couldn't fetch all team info :(",
                });
            }
        },
        refreshPlaygrounds() {
            const { query: id } = this.$route.params;
            this.getTeamPlaygrounds(id);
        },
    },
    watch: {
        '$route.params'() {
            this.fetchData();
        }
    }
}
</script>

<style scoped>
.container > * + * {
    margin-top: 10px;
}
</style>